<template>
	<div>
		<ig-iframe :src="src" height="120vh" style="margin: 0px 18px"></ig-iframe>
	</div>
</template>

<script>
import igIframe from '@/components/client/iframe/ig-iframe.vue';
export default {
	data() {
		return {
			src: 'https://docs.qq.com/doc/p/24f0f1f1bf1c66343ef7e9a9e67c5edf4d9ffd4c?dver=3.0.27554990',
		};
	},
	components: {
		igIframe,
	},
};
</script>

<style lang="scss" scoped></style>
